import { FUEL_TYPE, SUPPLIER_FUEL_TYPE } from "./tariffInfo";

export const FUEL_FLAG_MAPPING = {
  [SUPPLIER_FUEL_TYPE.ELECGAS]: "B",
  [FUEL_TYPE.ELECGAS]: "B",
  [SUPPLIER_FUEL_TYPE.ELEC]: "E",
  [FUEL_TYPE.ELEC]: "E",
  [SUPPLIER_FUEL_TYPE.GAS]: "G",
  [FUEL_TYPE.GAS]: "G"
}